import React from 'react';

import './ServicePage.css';

const PopularCategories = () => (
  <div className="service-page">
    <h1>Popular Categories</h1>
    <p>Browse popular service categories.</p>
  </div>
);

export default PopularCategories;
